import {IHttpPromise, IHttpService} from "angular";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import {Page} from "../../utils/models/Page";
import {ImportReportLogFilter} from "../../opportunities_filter/model/OpportunityFilterUi";
import {ReportLog} from "../model/ReportLog";
import {ImportLogConfigs} from "../model/ImportLogConfigs";
import {IMessage} from "@stomp/stompjs";
import {WebSocketTopicName} from "../../websocket_service/model/WebSocketTopicName";
import {WebSocketServiceName} from "../../utils/names/serviceNames";
import {WebSocketService} from "../../websocket_service/service/WebSocketService";

export class ManualImportService {

    public static instance = [
        '$http',
        WebSocketServiceName,
        ManualImportService
    ];

    constructor(private $http: IHttpService,
                private webSocketService: WebSocketService) {
    }

    public getLogs = (page: number,
                      size: number,
                      filter: ImportReportLogFilter): IHttpPromise<Page<ReportLog>> => {
        // let endDate = filter.endDate;
        // filter.endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() + 1)
        return this.$http({
            method: 'POST',
            url: getAbsoluteUrl('api/import/report/log'),
            params: {page: page, size: size},
            data: filter
        });

    };

    executeManualImport = (configs: ImportLogConfigs, file: File, employeeId: number): IHttpPromise<any> => {

        let formData = new FormData();
        formData.append('importSource', configs.importSource);
        if (file) {
            formData.append('file', file);
        }
        if (configs.title) {
            formData.append('title', configs.title);
        }
        if (employeeId) {
            formData.append('employee_id', employeeId.toString());
        }

        return this.$http({
            method: 'POST',
            url: getAbsoluteUrl('api/import/manual'),
            data: formData,
            headers: {'Content-Type': undefined},
        })
    };

    startImportLogsSession = (messageCallback: (message: IMessage) => void) => {
        this.webSocketService.startSession(WebSocketTopicName.PENDING_MANUAL_IMPORTS_TOPIC, messageCallback)
    };

    stopImportLogsSession = () => {
        this.webSocketService.stopSession(WebSocketTopicName.PENDING_MANUAL_IMPORTS_TOPIC);
    };


}